import { render, staticRenderFns } from "./SetCaptainModal.vue?vue&type=template&id=6f8a8a8e&"
import script from "./SetCaptainModal.vue?vue&type=script&lang=js&"
export * from "./SetCaptainModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports